<script>
    import { onDestroy } from "svelte";
    import Button from "../../windows/Button.svelte";

    const BUFFER_SIZE = 4096;

    export let volume = 1.5;

    let context;
    let isSuspended = true;

    function resume() {
        if (typeof AudioContext === "undefined") {
            return;
        }

        if (context && context.disconnect) {
            context.disconnect();
        }

        context = new AudioContext();

        const noise = (function () {
            let lastOut = 0.0;

            const node = context.createScriptProcessor(BUFFER_SIZE, 1, 1);

            node.onaudioprocess = (e) => {
                const output = e.outputBuffer.getChannelData(0);

                for (let i = 0; i < BUFFER_SIZE; i++) {
                    const white = Math.random() * 2 - 1;
                    output[i] = (lastOut + 0.02 * white) / 1.02;
                    lastOut = output[i];
                    output[i] *= volume;
                }
            };

            return node;
        })();

        const highShelf = context.createBiquadFilter();
        highShelf.type = "highshelf";
        highShelf.frequency.value = 22000;
        highShelf.gain.value = 25 * volume;

        const lowShelf = context.createBiquadFilter();
        lowShelf.type = "lowshelf";
        lowShelf.frequency.value = 135 * volume;
        lowShelf.gain.value = 10;

        noise.connect(highShelf);
        highShelf.connect(lowShelf);
        lowShelf.connect(context.destination);

        setTimeout(() => {
            isSuspended = context.state === "suspended";
        }, 100);
    }

    resume();

    onDestroy(() => {
        if (context) {
            context.close();
        }
    });
</script>

<div class="noise" class:suspended={isSuspended}>
    {#if isSuspended}
        <div class="resume">
            <Button action={resume}>Unmute</Button>
        </div>
    {/if}
</div>

<style>
    .noise {
        display: none;
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .noise.suspended {
        display: block;
    }

    .resume {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-60%);
        box-shadow: calc(var(--chrome-depth) * 2) calc(var(--chrome-depth) * 2)
            rgba(0, 0, 0, 0.5);
    }
</style>
